/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsNotificationChannelOverrideDtoSchema } from "./notificationChannelOverrideDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsUserNotificationSettingsDtoSchema = z.object({
  email: z.optional(z.boolean()),
  tournamentStart: z.optional(z.boolean()),
  newsAndRecommendations: z.optional(z.boolean()),
  emailTeams: z.optional(z.boolean()),
  discordEnabled: z.optional(z.boolean()),
  discordSendAll: z.optional(z.boolean()),
  discordTypes: z.array(z.string()).nullish(),
  discordTournaments: z.optional(z.boolean()),
  discordMatches: z.optional(z.boolean()),
  discordTeam: z.optional(z.boolean()),
  preset: z.string().nullish(),
  get channelOverrides() {
    return z
      .array(goodLuckCoreDTOsNotificationChannelOverrideDtoSchema)
      .nullish();
  },
});
